function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
import React from 'react';
import { CheckBox } from "../checkbox/checkbox.component";
import { SelectItem } from "./selectItem.component";

/**
 * A group of items displayed in Select.
 * Groups should be rendered within Select and contain SelectItem components to provide a useful component.
 *
 * @extends React.Component
 *
 * @property {ReactElement<SelectItemProps> | ReactElement<SelectItemProps>[]} children -
 * items to be rendered within group.
 *
 * @property {ReactText | (TextProps) => ReactElement} title - String, number or a function component
 * to render within the group.
 * If it is a function, expected to return a Text.
 *
 * @property {(ImageProps) => ReactElement} accessoryLeft - Function component
 * to render to start of the *title*.
 * Expected to return an Image.
 *
 * @property {(ImageProps) => ReactElement} accessoryRight - Function component
 * to render to end of the *title*.
 * Expected to return an Image.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example SelectWithGroups
 */
export class SelectGroup extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "createAccessoryProps", props => {
      return {
        checked: props.selected,
        onChange: () => props.onPress && props.onPress(props.descriptor)
      };
    });

    _defineProperty(this, "createGroupedItemProps", props => {
      const accessoryProps = this.createAccessoryProps(props);
      return {
        appearance: 'grouped',
        accessoryLeft: evaProps => this.renderAccessory(_objectSpread(_objectSpread({}, evaProps), accessoryProps))
      };
    });

    _defineProperty(this, "renderAccessory", props => {
      if (!this.isMultiSelect) {
        return null;
      }

      return /*#__PURE__*/React.createElement(CheckBox, props);
    });

    _defineProperty(this, "renderGroupedItems", source => {
      return React.Children.map(source, (item, key) => {
        const groupedProps = this.createGroupedItemProps(item.props);
        return /*#__PURE__*/React.cloneElement(item, _objectSpread(_objectSpread({
          key
        }, groupedProps), item.props));
      });
    });
  }

  get isMultiSelect() {
    if (this.props.descriptor) {
      return this.props.descriptor.multiSelect;
    }

    return false;
  }

  get groupAccessoryState() {
    const nestedElements = React.Children.toArray(this.props.children);
    const selectedElements = nestedElements.filter(el => el.props.selected);
    const indeterminate = selectedElements.length > 0 && selectedElements.length < nestedElements.length;
    const checked = selectedElements.length === nestedElements.length;
    return {
      checked,
      indeterminate
    };
  }

  get groupAccessoryProps() {
    return _objectSpread(_objectSpread({}, this.createAccessoryProps(this.props)), this.groupAccessoryState);
  }

  render() {
    const _this$props = this.props,
          {
      children
    } = _this$props,
          itemProps = _objectWithoutProperties(_this$props, ["children"]);

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectItem, _extends({
      accessoryLeft: evaProps => this.renderAccessory(_objectSpread(_objectSpread({}, evaProps), this.groupAccessoryProps))
    }, itemProps)), this.renderGroupedItems(children));
  }

}